import { api } from '@common';
import { useQuery } from '@tanstack/react-query';

interface CustomerInterface {
	data: {
		id: string;
		name: string;
		cpf: string;
		maritalStatus: string;
		propertyRegime?: string;
		updatedAt: string;
		advisor: {
			id: string;
			email: string;
			name: string;
		};
		office: {
			id: string;
			name: string;
			avatar?: string;
			cnpj?: string;
			phone?: string;
		};
		patrimony: number;
	}[];
	pagination: {
		currentPage: number;
		pageCount: number;
		totalCount: number;
	};
}

export const useCustomer = (params?: {
	page?: number;
	limit?: number;
	search?: string;
	orderBy?: string;
	orderType?: string;
}) =>
	useQuery<CustomerInterface>({
		queryKey: ['customer', 'list', params],
		queryFn: () =>
			api
				.get('/customer', {
					params,
				})
				.then((res) => res.data),
		refetchOnWindowFocus: false
	});
